import {FormControl, Grid, Skeleton} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { BooleanInput, Form, TextInput, useNotify, useRecordContext, useTranslate } from 'react-admin'
import { useWatch, useFormContext } from 'react-hook-form'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { useQuery } from 'react-query'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { clientServices } from 'src/services/auth/client/client.service'
import { productServices } from 'src/services/reservation/product/product.service'
import { supplierServices } from 'src/services/reservation/supplier/supplier.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { processServices } from 'src/services/auth/process/process.service'
import { LoadingButton } from '@mui/lab'
import { ArrayConditions } from './ArrayConditions'

const SelectArrayInputFn = ({
  queryName,
  label,
  optionsText = ['long_name'],
  optionValue = ['id'],
  source,
  changeParam = null,
  queryFn,
  isLoading = false,
  setHashClient = null,
  multiple = false,
  ...props
}) => {
    const options =   useQuery([queryName, changeParam], () => queryFn())
  return (options.isLoading || options.isFetching) ? (
    <Skeleton variant='rectangular' width={'270px'} height={'40px'} />
  ) : (
    <FormControl fullWidth className='select-array-input'>
      {/* {label && <InputLabel>{label}</InputLabel>} */}
      <SelectInput
        source={source}
        options={options?.data || []}
        optionsText={optionsText}
        onChange={(value) => {
            if(setHashClient){
                const selected = options?.data?.find(item => item.hash_client === value.target.value)
                setHashClient(selected.hash_client)
            }
        }}
        optionValue={optionValue}
        showSearch
        multiple = {multiple}
        {...props}
      />
    </FormControl>
  )
}

const SyncMirrorReservation = ({ onChange }) => {
  const { control } = useFormContext()

  // escucha TODO el form
  const values = useWatch({ control })

  useEffect(() => {
    onChange(values)
  }, [values])

  return null
}

export const MirrorTab = () => {
    const notify = useNotify()
    const translate = useTranslate()
    const [mirrorReservation, setMirrorReservation]= useState()
    const [hashClient, setHashClient] = useState(null)
    const [processInfo, setProcessInfo] = useState(null)
    const [loadingEdit, setLoadingEdit] = useState(false)
    const [getProcessLoading, setGetProcessLoading] = useState(false)
    const record = useRecordContext()

    const getMirrorPorcess = async () =>{
        setGetProcessLoading(true)
        await clientServices.getMirrorProcessByClient(record.id).then((res)=>{
            //res.config
            setProcessInfo(res[0] ?? null)
            setMirrorReservation({...res[0].config, state:res[0].state})
            setHashClient(res[0].config?.client_to?.hash_client)
        }).finally(()=>{
            setGetProcessLoading(false)
        })
    }
    
    useEffect(()=>{
        getMirrorPorcess()
    },[])

    const onSubmit = async() =>{
        const config = {
            ...mirrorReservation,
            days_range:Number(mirrorReservation.days_range)
        }
        const body = {...processInfo,config, state:mirrorReservation.state}
        delete body.module
        delete body.created_at
        delete body.updated_at
        delete body.client
        setLoadingEdit(true)
        await processServices.editMirrorProcessByClient(processInfo.id, body).then(()=>{
            notify('ra.notification.mirror_edit_success',{type:'success'})
        }).catch(()=>{
            notify('ra.notification.mirror_edit_error',{type:'error'})
        }).finally(()=>{
            setLoadingEdit(false)
        })
    }

  return (
    <>
        {
            !processInfo ?
            <label>
                {translate('ra.message.no_client_mirror')}
            </label> :
        <Form record = {mirrorReservation}>
            <SyncMirrorReservation
                onChange={(values) => {
                setMirrorReservation(values)
                }}
            />
            <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.product')} md={12} lg={12}>
                    <SelectArrayInputFn
                        source='product_id'
                        queryName='product-all'
                        label={translate('ra.field.product')}
                        queryFn={productServices.getByAll}
                        multiple = {true}
                    />
                </EditInputsWrap>
            </Grid>
            <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.supplier')} md={12} lg={12}>
                    <SelectArrayInputFn
                        source='supplier_id'
                        queryName='supplier-all'
                        label={translate('ra.field.supplier')}
                        queryFn={() => supplierServices.getByParam({ limit: 999 })}
                        optionsText={['name']}
                        multiple = {true}
                    />
                </EditInputsWrap>
            </Grid>
            <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.status')} md={12} lg={12}>
                    <SelectInput
                    source={'status'}
                    options={[
                        {id:'CONFIRMED', label:translate('ra.status.CONFIRMED')}, 
                        {id:'INVOICED', label:translate('ra.status.INVOICED')},
                        {id:'PENDING', label:translate('ra.status.PENDING')}
                    ]}
                    optionsText={['label']}
                    optionValue={['id']}
                    multiple
                    />
                </EditInputsWrap>
            </Grid>
            <ArrayConditions/>
            <Grid container spacing={3}>
                <EditInputsWrap label={`${translate('ra.field.client')} ${translate('ra.field.destination')}`} md={6} lg={6}>
                    <SelectArrayInputFn
                        source='client_to.hash_client'
                        queryName='client-all'
                        label={`${translate('ra.field.client')} ${translate('ra.field.destination')}`}
                        setHashClient = {setHashClient}
                        optionValue={['hash_client']}
                        queryFn={() => clientServices.getByAll({ limit: 999 })}
                        optionsText={['long_name']}
                    />
                </EditInputsWrap>
                <EditInputsWrap key={hashClient} label={translate('ra.field.work_unit')} md={6} lg={6}>
                    <SelectArrayInputFn
                        source='client_to.work_unit_id'
                        queryName='work-unit-all'
                        label={translate('ra.field.work_unit')}
                        optionValue={['id']}
                        changeParam={hashClient}
                        queryFn={()=>workUnitServices.getByAll({hash_client:hashClient, limit: 999 })}
                        optionsText={['long_name']}
                    />
                </EditInputsWrap>
            </Grid>
            <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.days')} md={6} lg={6}>
                <TextInput
                    type='number'
                    source='days_range'
                    label={''}
                />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.is_active')} md={6} lg={6}>
                    <BooleanInput source="state" label=''/>
                </EditInputsWrap>
            </Grid>
            <LoadingButton
                variant='contained'
                onClick={onSubmit}
                loading={loadingEdit || getProcessLoading}
            >
                {`${translate('ra.action.edit')} mirror`}
            </LoadingButton>
        </Form>
        }
    </>
  )
}
